import styled, { css } from 'styled-components'
import { tabletMinWidth, mobileWidth } from '../mixins';


const StyledLayout = styled.div`
  ${({ mapLayout, successNewLayout }) => css`
    width: 100%;
    min-height: 100%;
    max-width: 375px;
    margin: 0 auto;
    padding: 16px 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    text-align: center;
    ${successNewLayout && `
      justify-content: flex-start;
      padding: 0;
    `};
    
    @media screen and (min-width: ${tabletMinWidth}px) {
      ${!successNewLayout && `justify-content: center;`};
      ${mapLayout && `max-width: 700px;`};
    }
    
    @media screen and (max-width: ${mobileWidth}px) {
      padding: 16px;
    }
    
    & > * {
      width: 100%;
    } 
  `};
`;

const Layout = ({ children, activePage }) => {
  const mapLayout = activePage === 'add-place';
  const successNewLayout = activePage === 'success';

  return (
    <StyledLayout mapLayout={mapLayout} successNewLayout={successNewLayout}>
      {children}
    </StyledLayout>
  );
};

export default Layout;